export default __webpack_public_path__ + "static/media/hero-01.de1e40eb.png";